import { t } from 'i18next';
import { BlankCell } from '../../components/Cells/BlankCell';
import { FilterConfiguration } from '../../components/FilterPanel/types';
import { TypographyOverflow } from '../../components/TypographyOverflow';
import { PaginatedTableController, PaginatedTableState } from '../../controllers/PaginatedTableController';
import { P11Template, getP11Label } from '../../enums/P11Template';
import { DefaultHeaderConfiguration, FieldConfiguration } from '../../types/paginated-table';

type State = PaginatedTableState & {};

type Props = {
  rows: P11Template[];
};

type Model = P11Template & { id: number };

export class KeyPCKS11AttributesTable extends PaginatedTableController<Model, Props, State> {
  protected getAdditionalDataGridProps() {
    return {
      ...super.getAdditionalDataGridProps(),
      hideFooter: true,
    };
  }

  protected getDefaultHeaderConfigurations(): DefaultHeaderConfiguration {
    return { title: t('pcks11InstancesTitle') };
  }

  protected getDefaultPageSize() {
    // Only used to render the skeleton, this table is not paginated
    return 5;
  }

  protected getFieldConfigurations(): FieldConfiguration<Model>[] {
    const keysOfP11Template: (keyof P11Template)[] = Object.keys(this.props.rows[0] || {}) as (keyof P11Template)[];
    const columns: FieldConfiguration<Model>[] = keysOfP11Template.map((key) => {
      const label = getP11Label(key);
      return {
        fieldKey: key as string,
        label,
        render: (row, { hasFocus }) => {
          const value = row[key];
          const displayValue = typeof value === 'boolean' ? (value ? t('true') : t('false')) : value;
          if (displayValue) {
            return <TypographyOverflow hasFocus={hasFocus}>{displayValue}</TypographyOverflow>;
          }
          return <BlankCell blankText={t('unknown')} />;
        },
      };
    });

    return columns;
  }

  protected getFilterConfigurations(): FilterConfiguration[] {
    return [];
  }

  protected async fetchData() {
    return {
      data: this.props.rows.map((row, index) => ({ id: index, ...row })),
      pageInfo: { hasNextPage: false, hasPreviousPage: false, startCursor: null, endCursor: null },
      totalCount: this.props.rows.length,
    };
  }
}
